import { Config } from '@adornis/config/config.js';

export const config = new Config('matching_week', {
  AZURE_FOUNDRY_URL: {
    client: false,
    env: true,
    name: 'AZURE_FOUNDRY_URL',
    required: true,
  },
  AZURE_FOUNDRY_API_KEY: {
    client: false,
    env: true,
    name: 'AZURE_FOUNDRY_API_KEY',
    required: true,
  },
});
